module.exports = __webpack_public_path__ + "img/img15.44801319.png";